import { rulesGenerators } from '~/core/utils/rulesGenerators'

export const TEXT_INPUT_RULES = {
  REQUIRED: rulesGenerators.required(),
  GREATER_THAN_ZERO: rulesGenerators.greaterThan(0),
}
